import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Loader from 'react-loader-advanced'
import { VelocityComponent } from 'velocity-react'
import apiservice from '../services/apiservices'
import '../static/css/forgotpassword.css'

class ForgotPassword extends Component {
    constructor() {
        super()
        this.state = {
            data: {},

            isLoading: true,
            isAuthentified: false,
            isAllowedToResetPassword: false,

            loadervisibility: 'none',
            errorVisibility: 'none',
            errorMessage: '',

            isResetPasswordCompleted: false
        }
        this.newPasswordInputComponent = null
        this.componentStillMounted = true
        this.retypePasswordInputComponent = null
    }

    componentWillMount() {
        this.authentifyUser()
    }

    componentWillUnmount() {
        this.componentStillMounted = false
    }

    authentifyUser = () => {
        let data = { "password_link": this.props.match.params.token }
        apiservice.verifyForgotPasswordToken(data)
            .then(responseData => {
                if (this.componentStillMounted) {
                    if (responseData && responseData.status === "SUCCESS") {
                        this.setState({ 
                            isLoading: false, 
                            isAuthentified: true, 
                            isAllowedToResetPassword: true,
                            data: responseData.data ? responseData.data : {} 
                        })
                    } else {
                        this.setState({ isLoading: false, isAuthentified: true, isAllowedToResetPassword: false })
                        // this.refs.velocity.runAnimation()
                    }
                }
            })
            .catch(err => {
                this.setState({ isLoading: false, isAuthentified: true, isAllowedToResetPassword: false })
                console.error("Error message: ", err)
                // this.refs.velocity.runAnimation()
            })
    }

    getUnAuthorisedComponent = () => {
        let HBB_logo = require('../../../static/img/bbms-logo.png')
        return (
            <div className="forgot-password-page">
            <div className="login-box forgot-password">
                <div className="login-logo">
                    <img style={{ height: '60px', alignContent: 'center' }} alt="GMS logo"
                        src={HBB_logo} />
                </div>
                <div className="login-box-body">
                    <div className="row">
                        <div className="col-md-2 col-sm-2 col-xs-2" style={{ textAlign: "center" }}>
                            <i className="fa fa-times fa-4x" />
                        </div>
                        <div className="col-md-10 col-sm-10 col-xs-10">
                            <p className="login-box-msg" style={{ fontWeight: 600 }}>
                                You can not be able to Reset password. Check for Reset password request expiry time.
                            </p>
                        </div>
                    </div>

                    <div className="row" style={{ marginTop: "40px" }}>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <p className="login-box-msg">
                                Click here to request for Reset Password link
                            </p>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <button className="btn btn-primary btn-block btn-flat submit-button"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.props.history.push("/forgotpasswordrequest")
                                }}>
                                Resend link
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        )
    }

    getResetPasswordComponent = () => {
        let HBB_logo = require('../../../static/img/bbms-logo.png')
        let effect = "tada"
        let animation = 'callout.' + effect
            return (
                <div className="forgot-password-page">
                <div className="forgot-password-page">
                <div className="login-box forgot-password-request">
                    <div className="login-logo">
                        <img style={{ height: '60px', alignContent: 'center' }} alt="GMS logo"
                            src={HBB_logo} />
                    </div>
                    <div className="login-box-body">
                        <p className="login-box-msg" style={{ fontWeight: 600 }}>
                            Reset your Password.
                        </p>

                        <form style={{ marginTop: "20px" }}>
                            <VelocityComponent ref="velocity" key={effect} animation={animation} runOnMount={false}>
                                <div>
                                    <div className="form-group has-feedback">
                                        <input type="password" className="form-control" placeholder="Enter your Password"
                                            ref={(el) => this.newPasswordInputComponent = el}
                                            onChange={(e) => {
                                                e.preventDefault()
                                                this.resetErrorMessage()
                                            }}
                                            onKeyPress={(e) => {
                                                var code = (e.keyCode ? e.keyCode : e.which);
                                                if (code === 13) { //Enter keycode                        
                                                    e.preventDefault()
                                                    this.retypePasswordInputComponent.focus()
                                                }
                                            }} />
                                        <span className="fa fa-lock form-control-feedback"></span>
                                    </div>
                                    <div className="form-group has-feedback">
                                        <input type="password" className="form-control" placeholder="Re-type your Password"
                                            ref={(el) => this.retypePasswordInputComponent = el}
                                            onChange={(e) => {
                                                e.preventDefault()
                                                this.resetErrorMessage()
                                            }}
                                            onKeyPress={(e) => {
                                                var code = (e.keyCode ? e.keyCode : e.which);
                                                if (code === 13) { //Enter keycode                        
                                                    e.preventDefault()
                                                    this.resetPasswordCall()
                                                }
                                            }} />
                                        <span className="fa fa-sign-in form-control-feedback"></span>
                                    </div>
                                </div>
                            </VelocityComponent>

                            <div className="row" style={{ marginTop: "40px" }}>
                                <div className="col-xs-12">
                                    <button className="btn btn-primary btn-block btn-flat submit-button"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            this.resetPasswordCall()
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                            <div
                                className="form-group has-error login-error-text"
                                style={{
                                    marginTop: "20px",
                                    marginRight: "10px",
                                    marginLeft: "5px",
                                    display: this.state.loadervisibility,
                                }}>
                                <label className="control-label loader" style={{ fontSize: "15px" }} />
                            </div>
                            <div
                                className="form-group has-error reset-error-text"
                                style={{
                                    marginTop: "20px",
                                    marginRight: "10px",
                                    marginLeft: "5px",
                                    display: this.state.errorVisibility,
                                }}>
                                <label className="control-label" style={{ fontSize: "15px" }} >
                                    {this.state.errorMessage}
                                </label>
                            </div>
                        </form>
                    </div>
                </div>
                </div>
                </div>
            )
    }

    resetErrorMessage = () => {
        this.setState({ loadervisibility: 'none', errorVisibility: 'none', errorMessage: '' })
    }

    resetPasswordCall = () => {
        this.setState({
            loadervisibility: 'block',
            errorVisibility: 'block',
            errorMessage: 'Loading'
        })

        let newPassword = this.newPasswordInputComponent.value.trim()
        let reTypedPassword = this.retypePasswordInputComponent.value.trim()

        if (newPassword) {
            if (newPassword.length > 5) {
                if (newPassword === reTypedPassword) {
                    this.resetPasswordRequestToServer()
                } else {
                    this.retypePasswordInputComponent.focus()
                    this.refs.velocity.runAnimation()
                    this.setState({
                        loadervisibility: 'none',
                        errorVisibility: 'block',
                        errorMessage: 'Re-typed password is not matching with New password, both should be same.'
                    })
                }
            } else {
                this.newPasswordInputComponent.focus()
                this.refs.velocity.runAnimation()
                this.setState({
                    loadervisibility: 'none',
                    errorVisibility: 'block',
                    errorMessage: 'Password should be greater than 5-digits'
                })
            }
        } else {
            this.newPasswordInputComponent.focus()
            this.refs.velocity.runAnimation()
            this.setState({
                loadervisibility: 'none',
                errorVisibility: 'block',
                errorMessage: 'Please enter your New Password'
            })
        }
    }

    resetPasswordRequestToServer = () => {
        let data = this.state.data
        data.new_password = this.newPasswordInputComponent.value.trim()
        
        apiservice.resetPassword(data)
            .then(responseData => {
                if (this.componentStillMounted) {
                    if (responseData.status === "SUCCESS") {
                        this.setState({
                            isResetPasswordCompleted: true,
                        })
                        this.setState({ loadervisibility: 'none', errorVisibility: 'none', errorMessage: '' })
                    } else {
                        this.setState({ 
                            loadervisibility: 'none', 
                            errorVisibility: 'block', 
                            errorMessage: responseData.reason 
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({ 
                    loadervisibility: 'none', 
                    errorVisibility: 'block', 
                    errorMessage: 'Something went wrong, Can not able to update Password' 
                })
                console.error("Error message: ", err)
            })
    }

    getPasswordResetSuccessComponent = () => {
        let HBB_logo = require('../../../static/img/bbms-logo.png')
        return (
         <div className="forgot-password-page">
            <div className="login-box forgot-password">
                <div className="login-logo">
                    <img style={{ height: '60px', alignContent: 'center' }} alt="GMS logo"
                        src={HBB_logo} />
                </div>
                <div className="login-box-body">
                    <div className="row">
                        <div className="col-md-2 col-sm-2 col-xs-2" style={{ textAlign: "center" }}>
                            <i className="fa fa-check fa-4x" />
                        </div>
                        <div className="col-md-10 col-sm-10 col-xs-10">
                            <p className="login-box-msg" style={{ fontWeight: 600 }}>
                                Your Password reset is successfull.
                            </p>
                        </div>
                    </div>

                    <div className="row" style={{ marginTop: "40px" }}>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <button className="btn btn-primary btn-block btn-flat submit-button"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.props.history.push("/")
                                }}>
                                Done
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        )
    }

    render() {
        let componentToBeRender = null

        if (this.state.isResetPasswordCompleted) {
            componentToBeRender = this.getPasswordResetSuccessComponent()
        } else {
            if (this.state.isAuthentified) {
                if (this.state.isAllowedToResetPassword) {
                    componentToBeRender = this.getResetPasswordComponent()
                } else {
                    componentToBeRender = this.getUnAuthorisedComponent()
                }
            } else {
                componentToBeRender =
                    <div className="main" style={{ textAlign: "center" }} />
            }
        }

        return (
            <div className="forgot-password">
                <Loader
                    show={this.state.isLoading}
                    message={'Fetching data. Please wait for a moment...'}
                    foregroundStyle={{ color: "#ffffff", fontSize: "17px", fontWeight: "600" }}>
                    {componentToBeRender}
                </Loader>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(withRouter(ForgotPassword))


// WEBPACK FOOTER //
// ./src/modules/ForgotPassword/Components/ForgotPassword.js